import { render, staticRenderFns } from "./ActionsSubmenu.vue?vue&type=template&id=fd657084&scoped=true"
import script from "./ActionsSubmenu.vue?vue&type=script&lang=js"
export * from "./ActionsSubmenu.vue?vue&type=script&lang=js"
import style0 from "./ActionsSubmenu.vue?vue&type=style&index=0&id=fd657084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd657084",
  null
  
)

export default component.exports